
// export const handelPrice = (price) => {
//     if(price!== undefined){
//         return( new Intl.NumberFormat().format(price.toString().replace(/[^0-9]/g, '')));
//     }
//     return price



// }

export const handelPrice = (price) => {
    if (price !== undefined) {
        return Number(price.toString().replace(/[^0-9]/g, '')).toLocaleString();
    }
    return price;
}

export const convertToWesternNumerals = (text = "") => {
    const map = {
        '۰': '0', '١': '1', '۱': '1', '٢': '2', '۲': '2',
        '٣': '3', '۳': '3', '٤': '4', '۴': '4', '٥': '5',
        '۵': '5', '٦': '6', '۶': '6', '٧': '7', '۷': '7',
        '٨': '8', '۸': '8', '٩': '9', '۹': '9', '٠': '0'
    };

    return text.replace(/[۰-۹٠-٩]/g, match => map[match]);
};


export const removeCama = (persianText) => {
    // persianText = persianText.replace(/,/g, '')
    // persianText = persianText.replace(/٬/g, '')
    persianText = persianText.split(',').join('');
    persianText = persianText.split('٬').join('');
    // Use regular expression to replace Persian numerals with Western numerals
    persianText = convertToWesternNumerals(persianText)

    return persianText;
};
export const HandelPaymentStatus = (id) => {
    let componentToRender;
    switch (id) {
        case 0:
            componentToRender = <span className={"direction-ltr text-info"}>درحال بررسی</span>;
            break;
        case 1:
            componentToRender = <span className={"direction-ltr text-success"}>پرداخت شده</span>;

            break;
        case 2:
            componentToRender = <span className={"direction-ltr text-danger"}>لغو شده</span>;
            break;

        default:
            componentToRender = "خطا";
    }
    return componentToRender
}

export const HandelCommissionCategory = (id, description) => {

    let componentToRender;
    switch (id) {
        case 0:
            componentToRender = <span className={"direction-ltr "}>عمومی</span>;
            break;
        case 1:
            componentToRender = <span className={"direction-ltr "}>واریز</span>;

            break;
        case 2:
            componentToRender = <span className={"direction-ltr "}>تبلیغات ورودی</span>;
            break;

        case 3:
            componentToRender = <span className={"direction-ltr "}>فعال سازی استخر {description}</span>;
            break;

        case 4:
            componentToRender = <span className={"direction-ltr "}>شارژ موبایل</span>;
            break;

        case 5:
            componentToRender = <span className={"direction-ltr "}>شارژ اینترنت</span>;
            break;
        case 6:
            componentToRender = <span className={"direction-ltr "}>پرداخت قبض</span>;
            break;
        case 7:
            componentToRender = <span className={"direction-ltr "}>طرح 1 - پارت {description}</span>;
            break;
        case 8:
            componentToRender = <span className={"direction-ltr "}>طرح 2 - پارت {description}</span>;
            break;
        case 9:
            componentToRender = <span className={"direction-ltr "}>طرح اول بیمه{description ? ' - ' + description : ''}</span>;
            break;
        default:
            componentToRender = "دیگر";
    }
    return componentToRender
}
export const isApp = () => {
    return window.location.hostname === 'app.karsood.ir';
    return navigator.userAgent.includes("KarsoodWebView")
};
export const formatCardNumber = (c) => {
    const cleaned = c.replace(/-/g, ''); // حذف کاماهای قبلی
    return cleaned.replace(/(\d{4})(?=\d)/g, '$1-');
};